export default __webpack_public_path__ + "static/media/vpIllegal.b50b6146.svg";